import {useEffect, useState, useRef} from 'preact/hooks';

import {moreModelServices} from '~/locals/qianfan/index';
import {useQfScreen} from '../comp/utils/hook';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'moreModelServices';
const moduleTitleClassName = 'qf-module-title';
const moduleDescClassName = 'qf-module-desc';
const moduleContentClassName = 'qf-module-content';

const MoreModelServices = () => {
    const {list, title} = moreModelServices;
    const {screenWidth} = useQfScreen();

    useCptDuration(id, {
        name: `${applicationName}-${title}-停留时长`
    });
    return (
        <>
            <div className="more-model-services" id={id}>
                <div className="module-wrapper">
                    <div className="module-container">
                        <h2 className={`title ${moduleTitleClassName}`}>{title}</h2>
                        <div className={`content ${moduleContentClassName}`}>
                            {list.map(item => {
                                return (
                                    <div className="item" key={item.id}>
                                        <p className="item-title">{item.title}</p>
                                        <p className="item-desc no_rem_fs_16">{item.desc}</p>
                                        <a
                                            className="item-link"
                                            href={item.href}
                                            target="_blank"
                                            rel="noreferrer"
                                            {...item.trackInfo}
                                        >
                                            <span className="link">{item.hrefText}</span>
                                            <span className="link-play"></span>
                                        </a>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="contact-us-container">
                <div className={`contact-us-content ${moduleContentClassName}`}>
                    {screenWidth > 768 ? (
                        <div className="contact-us-title_pc">百度智能云千帆 · 千帆竞发 · 智能领航</div>
                    ) : (
                        <div className="contact-us-title_mobile">
                            百度智能云千帆
                            <br />
                            千帆竞发 · 智能领航
                        </div>
                    )}
                    <div className="contact-us-introduce">企业级一站式大模型与AI原生应用开发及服务平台</div>
                    <div className="contact-us-button">
                        <a
                            href="https://cloud.baidu.com/survey/modelbuilder-product.html"
                            target="_blank"
                            className="contact-us-button-link"
                            data-track-category="新官网页PC-底部通栏"
                            data-track-name="百度智能云千帆·千帆竞发·智能领航"
                            data-track-value="联系我们"
                        >
                            联系我们
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MoreModelServices;
